/**
 * Copy and defaults for the fpLeads (MGL Management) toolkit fields, shared by
 * the per-conference form and the reusable-config create/edit forms. All three
 * values come from MGL's "Developer's API Information" email. The API key and
 * user ID are stored as secrets: the user ID is also the fpLeads portal login.
 */
export const FPLEADS_DEFAULT_BASE_URL = 'https://api.fpleads.io/api/Events';

export const FPLEADS_BASE_URL_EXTRA =
  'The "End Point" from MGL\'s Developer\'s API Information email. The default is the fpLeads production API.';

export const FPLEADS_SECRETS_EXTRA =
  'From the same email. Never paste these into Slack or a shared doc.';

/** Same rule as the server: reject (never trim) a value with surrounding spaces. */
export const FPLEADS_WHITESPACE_RULE = {
  validator: (_: unknown, v?: string) =>
    !v || v === v.trim() ? Promise.resolve() : Promise.reject(new Error('Value has leading or trailing spaces')),
};

/** Same rule as the server (zod url, protocol https): the fpLeads API is https-only. */
export const FPLEADS_HTTPS_RULE = {
  pattern: /^https:\/\//i,
  message: 'Base URL must start with https://',
};
